import React from "react"
import { Box, Divider, Stack, Typography, useMediaQuery, useTheme } from "@carrotfertility/carotene-core"
import sprintsDesignedByAsimaAhmadSrc from "#/features/sprints-landing/assets/images/sprints-designedby-asima-ahmad.jpg"
import sprintsDesignedByRichardLegroSrc from "#/features/sprints-landing/assets/images/sprints-designedby-richard-legro.jpg"
import sprintsDesignedByJavineMcLaughlinSrc from "#/features/sprints-landing/assets/images/sprints-designedby-javine-mclaughlin.jpg"
import { SPRINTS_MESSAGES } from "#/features/sprints-landing/en-only-text"

const designedByItems = [
  {
    id: "asima-ahmad",
    image: sprintsDesignedByAsimaAhmadSrc,
    name: SPRINTS_MESSAGES.designedBy.asimaAhmad.name,
    title: SPRINTS_MESSAGES.designedBy.asimaAhmad.title,
    description: SPRINTS_MESSAGES.designedBy.asimaAhmad.description
  },
  {
    id: "richard-legro",
    image: sprintsDesignedByRichardLegroSrc,
    name: SPRINTS_MESSAGES.designedBy.richardLegro.name,
    title: SPRINTS_MESSAGES.designedBy.richardLegro.title,
    description: SPRINTS_MESSAGES.designedBy.richardLegro.description
  },
  {
    id: "javine-mclaughlin",
    image: sprintsDesignedByJavineMcLaughlinSrc,
    name: SPRINTS_MESSAGES.designedBy.javineMcLaughlin.name,
    title: SPRINTS_MESSAGES.designedBy.javineMcLaughlin.title,
    description: SPRINTS_MESSAGES.designedBy.javineMcLaughlin.description
  }
]

export function DesignedBy() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  return (
    <Box>
      <Typography variant="h3" sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.xl })}>
        {SPRINTS_MESSAGES.designedBy.title}
      </Typography>
      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={theme.tokens.spacing.sm}
        divider={
          <Divider
            orientation={isMobile ? "horizontal" : "vertical"}
            sx={(theme) => ({ borderColor: theme.palette.background.paper })}
            flexItem
          />
        }
      >
        {designedByItems.map((item) => (
          <Box
            key={item.id}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: theme.tokens.spacing.md,
              alignItems: isMobile ? "center" : "flex-start",
              textAlign: isMobile ? "center" : "start"
            }}
          >
            <Box
              component="img"
              src={item.image}
              alt={""}
              sx={(theme) => ({
                blockSize: 80,
                inlineSize: 80,
                borderRadius: theme.tokens.borderRadius.md
              })}
            />
            <div>
              <Typography variant="body1">{item.name}</Typography>
              <Typography variant="body2" sx={{ fontSize: "12px" }}>
                {item.title}
              </Typography>
            </div>
            <Typography variant="body2">{item.description}</Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  )
}
